import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(VTextField, {
        attrs: {
          outlined: "",
          small: "",
          dense: "",
          placeholder: _vm.$t("my_tasks.modals.type_search"),
          "prepend-inner-icon": "icon-search",
        },
        on: {
          keyup: function () {
            _vm.filter = _vm.inputSearch
          },
        },
        model: {
          value: _vm.inputSearch,
          callback: function ($$v) {
            _vm.inputSearch = $$v
          },
          expression: "inputSearch",
        },
      }),
      _c(VDataTable, {
        staticClass: "table-inca",
        attrs: {
          headers: _vm.headers,
          items: _vm.item.views,
          search: _vm.inputSearch,
          "hide-default-footer":
            Object.keys(_vm.item.views).length <= 10 ? true : false,
        },
        scopedSlots: _vm._u([
          {
            key: "item.add_objects",
            fn: function (row) {
              return _vm._l(row.item.add_objects, function (add_object, index) {
                return _c(
                  "b-badge",
                  { key: "add_object-" + index, attrs: { variant: "light" } },
                  [_vm._v(_vm._s(add_object))]
                )
              })
            },
          },
          {
            key: "item.preview_image",
            fn: function (row) {
              return [
                _c(
                  VTooltip,
                  {
                    attrs: { bottom: "" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "activator",
                          fn: function (ref) {
                            var on = ref.on
                            var attrs = ref.attrs
                            return [
                              row.item.preview_image
                                ? _c(
                                    VBtn,
                                    _vm._g(
                                      _vm._b(
                                        {
                                          staticClass: "btn-icon-inca",
                                          attrs: { icon: "", small: "" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.showModal(row.item)
                                            },
                                          },
                                        },
                                        "v-btn",
                                        attrs,
                                        false
                                      ),
                                      on
                                    ),
                                    [_c(VIcon, [_vm._v("icon-view")])],
                                    1
                                  )
                                : _vm._e(),
                            ]
                          },
                        },
                      ],
                      null,
                      true
                    ),
                  },
                  [_c("span", [_vm._v(_vm._s(_vm.$t("my_tasks.view")))])]
                ),
              ]
            },
          },
        ]),
      }),
      _c(
        "b-modal",
        {
          ref: "modal-preview-image",
          attrs: { title: _vm.currentView.name, "hide-footer": "" },
        },
        [_c("b-img", { attrs: { src: _vm.currentImage.base64, fluid: "" } })],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }